import { Component, Inject, OnInit, signal } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { PageEvent } from "@angular/material/paginator";

import { Router } from "@angular/router";
import { EvaluationService } from "app/services/evaluation/evaluation.service";
import { ImagesService } from "app/services/helper/images.service";
import moment from "app/util/dayjs";
@Component({
    selector: "app-dialog-notas-evaluacion",
    templateUrl: "./dialog-notas-evaluacion.component.html",
    styleUrls: ["./dialog-notas-evaluacion.component.scss"],
    standalone: false
})
export class DialogNotasEvaluacionComponent implements OnInit {
    personas: Array<any> = [];
    evaluado: any;
    period: any;
    procesando: boolean = false;
    page = 0;
    allperiod = 0;
    readonly totalNotas = signal(0);

    readonly notas = signal<any[]>([]);
    selectedNota: null;
    newNotaName = "";
    tipoSeleccionadoCrear: string = "";

    notaActualizar = "";
    tipoSeleccionadoEditar: string = "";

    public displayedColumns: string[] = ["nota", "tipo", "fecha", "actions"];

    tiposAnotaciones: any[] = [];

    constructor(
        private formBuilder: UntypedFormBuilder,
        private evSvc: EvaluationService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private imagesSvc: ImagesService,
        private dialogRef: MatDialogRef<DialogNotasEvaluacionComponent> // Inyecta MatDialogRef
    ) {
        this.evaluado = dialogData.evaluado;
        this.period = dialogData.period;
    }
    ngOnInit() {
        this.getNotas();
        this.evSvc.getAnnotationesTipos().subscribe((data) => {
            this.tiposAnotaciones = data?.tipos ?? [];
            console.log(this.tiposAnotaciones);
        });
    }

    cerrar() {
        this.dialogRef.close();
    }

    getNotas() {
        this.evSvc
            .getAnnotationes(8, this.page, this.evaluado, { period: this.period.id, allperiod: this.allperiod })
            .subscribe((data) => {
                this.notas.set([...(data.anotaciones ?? [])]);
                console.log(this.notas());
            });
        this.evSvc
            .getAnnotationesTotal(this.evaluado, { period: this.period.id, allperiod: this.allperiod })
            .subscribe((data) => {
                this.totalNotas.set(data.total ?? 0);
                console.log(this.totalNotas());
            });
    }

    parseDate(date) {
        if (date) {
            return moment(date).format("DD-MM-YYYY HH:mm");
        } else {
            return "";
        }
    }

    getTipoNombre(tipo: string | number): string {
        if (!tipo) return "Desconocido";
        const tipoEncontrado = this.tiposAnotaciones.find((t) => t.value === String(tipo));
        return tipoEncontrado ? tipoEncontrado.name : "Desconocido";
    }

    getColorEstilo(color: number | null | undefined): string {
        const colores: { [key: number]: { border: string; background: string } } = {
            1: { border: "#ff9999", background: "#ffe0e0" }, // rojo pastel
            2: { border: "#99d699", background: "#e0f5e0" }, // verde pastel
            3: { border: "#99b3ff", background: "#e0edff" }, // azul pastel
            4: { border: "#ffeb99", background: "#fff9e0" }, // amarillo pastel
            5: { border: "#ffcc99", background: "#fff0e0" }, // naranja pastel
            6: { border: "#cc99cc", background: "#f0e0f0" }, // morado pastel
            7: { border: "#ffb3d9", background: "#ffe0f0" }, // rosa pastel
            8: { border: "#d4a574", background: "#f0e6d4" }, // marrón pastel (beige)
            9: { border: "#b3b3b3", background: "#e8e8e8" } // gris pastel
        };

        const colorNumero = color || 1; // Por defecto rojo si no existe o es null/undefined
        const colorSeleccionado = colores[colorNumero] || colores[1]; // Por defecto rojo si no existe
        return `border: 1px solid ${colorSeleccionado.border}; padding: 4px; border-radius: 5px; background-color: ${colorSeleccionado.background}`;
    }

    pageChanged(event: PageEvent) {
        this.page = event.pageIndex;
        this.getNotas();
    }

    eliminar(nota) {
        this.evSvc.deleteNota(nota.id).subscribe((data) => {
            this.getNotas();
        });
    }
    anadirNota(menuTrigger: MatMenuTrigger) {
        this.evSvc
            .postNota({ nota: this.newNotaName, personId: this.evaluado, tipo: this.tipoSeleccionadoCrear })
            .subscribe((data) => {
                this.newNotaName = "";
                this.tipoSeleccionadoCrear = "";
                this.getNotas();
                menuTrigger.closeMenu();
            });
    }
    editarNota(nota, menuTrigger: MatMenuTrigger) {
        this.evSvc
            .updateNota(nota.id, { nota: this.notaActualizar, tipo: this.tipoSeleccionadoEditar })
            .subscribe((data) => {
                this.notaActualizar = "";
                this.tipoSeleccionadoEditar = "";
                this.getNotas();
                menuTrigger.closeMenu();
            });
    }

    changeAllperiod($event) {
        this.allperiod = $event.checked ? 1 : 0;
        this.page = 0;
        this.getNotas();
    }
    selectNota(nota) {
        this.notaActualizar = nota.nota;
        if (nota.tipo) {
            this.tipoSeleccionadoEditar = nota.id_tipo;
        } else {
            this.tipoSeleccionadoEditar = "";
        }
    }

    cancel() {
        this.dialogRef.close();
    }
}
